import cn from 'classnames'
import React from 'react'
import { createPortal } from 'react-dom';

const SimilarDestinationsDesktop = ({
  stepConfig,
  handleClick,
  isActive,
  destinationName,
  onContinueClick,
}) => {
  const footerPortal = document.getElementById('wizard-next-button');

  return (
    <div className="wizard-similar-destinations-step">
      <p className="mb-8 heading-large text-primary">{stepConfig.title}</p>
      <div className="wizard-step__options">
        {
          stepConfig.items.map((item, i) => (
            <div
              key={i}
              onClick={() => handleClick(item.value)}
              className={cn('wizard-destination-button-desktop', {
                'active': isActive(item.value),
                'accent': i === 1
              })}
            >
              {item.text.replace('%destination%', destinationName)}
            </div>
          ))
        }
      </div>

      {footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={onContinueClick}>
          {stepConfig.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </div>
  )
}

export default SimilarDestinationsDesktop
